// extracted by mini-css-extract-plugin
export default {"container":"_K-z","topReviewHeading":"aL-z","criticalReview":"bL-z","favorableReview":"cL-z","vsSeparator":"dL-z"};